// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu-module--root--3Jo-H","inHero":"Menu-module--inHero--399xA","link":"Menu-module--link--2qDRN","links":"Menu-module--links--ryJGb","logo":"Menu-module--logo--sS_d5"};